<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>

                    <b-col sm="6" md="5" class="m-t-5px p-a-0">
                        <multiselect v-model="b_processo"
                        :options="optionsBProcesso"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Processo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="descr" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Descrição</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-mask="'##/##/#### ##:##:##'" v-model="dt_inicio" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data/Hora inicio detalhe</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-mask="'##/##/#### ##:##:##'" v-model="dt_fim" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data/Hora fim detalhe</label>
                        </div>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <multiselect v-model="monitor_status"
                        :options="optionsMonitorStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status Monitor"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <multiselect v-model="monitor_status_processo"
                        :options="optionsMonitorStatusProcesso"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status Processo"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px p-a-0">
                        <multiselect v-model="tp_detalhe"
                        :options="optionsTpDetalhe"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Tipo do detalhe"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>

                    <b-col sm="6" md="3" class="m-t-5px">
                      <div class="input-group-btn">
                        <div class="btn-group">
                          <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                          <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                        </div>
                      </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      descr: '',
      dt_inicio: '',
      dt_fim: '',
      b_processo: [],
      tp_detalhe: [],
      monitor_status: [],
      monitor_status_processo: [],
      optionsBProcesso: [],
      optionsTpDetalhe: [],
      optionsMonitorStatus: [],
      optionsMonitorStatusProcesso: [],
      data_filter: [],
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  mounted() {
      this.getLivGeral();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.data_filter = {descr: this.descr,
                              tp_detalhe: this.tp_detalhe,
                              dt_inicio: this.dt_inicio,
                              dt_fim: this.dt_fim,
                              monitor_status: this.monitor_status,
                              monitor_status_processo: this.monitor_status_processo,
                              b_processo: this.b_processo
                             }
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.cd = '';  // clear the text in text input
        this.tp_detalhe = '';
        this.dt_inicio = '';
        this.dt_fim = '';
        this.b_processo = '';
        this.monitor_status = '';
        this.monitor_status_processo = '';
        this.tp_detalhe = '';
        this.$events.fire('filter-reset');
      },
      getLivGeral() {
          this.helpForm.get('/api/monitorprocesso/jsonlistfiltros').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.bprocesso.forEach((obj)=>
              {
                  this.optionsBProcesso.push({ label: obj.cd+" - "+obj.descr, value: obj.bprocesso_id })
              })

              response.monitor_processo_status.forEach((obj)=>
              {
                  this.optionsMonitorStatusProcesso.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
              })

              response.monitor_processo_status_processo.forEach((obj)=>
              {
                  this.optionsMonitorStatus.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
              })

              response.tp_detalhe.forEach((obj)=>
              {
                  this.optionsTpDetalhe.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
              })
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });
      },
  },
  computed: {
      vuetableFilterButton: {
          get () {
              return this.$store.state.vuetable.filterButton;
          },
      },
  }
}
</script>
